import { useNavigate } from 'react-router-dom'

import { AppRoutes } from '@/constants/appRoutes'

import { EUserPermission, EUserRole } from './usePermissions/permissions.type'
import { usePermissions } from './usePermissions/usePermissions'

export const useRedirectBasedOnPermissions = () => {
  const navigate = useNavigate()
  const { hasPermission } = usePermissions()

  const hasHandleBillingRedirect = () => {
    if (!hasPermission(EUserPermission.HANDLE_BILLING, EUserRole.OWNER)) {
      navigate(AppRoutes.dashboard)
    }
  }

  const hasHandleCreditsRedirect = () => {
    if (!hasPermission(EUserPermission.HANDLE_CREDITS, EUserRole.OWNER)) {
      navigate(AppRoutes.dashboard)
    }
  }

  const hasHandleEnterprisesRedirect = () => {
    if (!hasPermission(EUserPermission.HANDLE_ENTERPRISES, EUserRole.OWNER)) {
      navigate(AppRoutes.dashboard)
    }
  }

  const hasViewReportsRedirect = () => {
    if (!hasPermission(EUserPermission.VIEW_REPORTS, EUserRole.READER)) {
      navigate(AppRoutes.dashboard)
    }
  }

  const hasHandleReportsRedirect = () => {
    if (!hasPermission(EUserPermission.HANDLE_REPORTS, EUserRole.OWNER)) {
      navigate(AppRoutes.reports)
    }
  }

  return {
    hasHandleBilling: hasHandleBillingRedirect,
    hasHandleCredits: hasHandleCreditsRedirect,
    hasHandleEnterprises: hasHandleEnterprisesRedirect,
    hasViewReports: hasViewReportsRedirect,
    hasHandleReports: hasHandleReportsRedirect,
  }
}
